import React, {Component} from 'react';
import {connect} from "react-redux";
import Annotation from "react-image-annotation";
import {Button, Col, Empty, Progress, Row, Spin, Tooltip, Typography} from 'antd';
import {bloodClass, bloodImageProperties} from '../utils/const';
import {
    CompressOutlined,
    LeftCircleOutlined,
    LoadingOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    RightCircleOutlined,
    ZoomInOutlined,
    ZoomOutOutlined
} from '@ant-design/icons';
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {convertSettingsToFilter, isNull, notNull} from "../utils/utils";

const {Text} = Typography;

export class Field100xView extends Component {

	constructor(props) {
		super(props);

		this.fld100xRef = React.createRef();

		this.state = {
			currZStackIndex: '',
			prevZstackIndex: '',
			zStacks: [],
			zStackStep: '',
			resetOnFirstLoad: true,
			loadingImage: false,
			annotations: [],
			pageRefresh: false,
        }
        this.imageHolder = React.createRef();
        document.addEventListener('keydown', this.pressShiftUp)
        document.addEventListener('keydown', this.pressShiftDown)
    }

    pressShiftUp = (event) => {
        if(event.shiftKey && event.keyCode === 38 ) {
            this.higherZstack();
        }
    }
    pressShiftDown = (event) => {
        if(event.shiftKey && event.keyCode === 40) {
            this.lowerZstack();
        }
    }

    async reposition () {
        if(this.props.mode === bloodClass.WBC || this.props.mode === bloodClass.RBC || this.props.mode === bloodClass.PLT){
            this.positionAndZoom();
            return;
        }
        if(this.props.mode === bloodClass.FIELD){
            this.resetPosition();

        }
    }

    resetPosition = () => {
        this.setState({
            image_updated: false,
        })
        if (this.imageHolder && this.imageHolder.current) {
            let x = ((2 * (document.documentElement.clientWidth))) / 100
            let y = document.documentElement.clientHeight / 8
            this.imageHolder.current.setTransform(x, y, document.documentElement.clientWidth * 0.00016)
            setTimeout(()=>{this.setState({pageRefresh:!this.state.page})},1000) //used to update zoom level display on top of image
        }
    }

    positionAndZoom = () => {
        
        // CHANGE MAGNIFICATION OF IMAGE ONLY THROUGH 'MAG' VARIABLE!!
        let MAG=0.334; //Value taken so that initial Load of WBC shows 100x

        if (this.imageHolder && this.imageHolder.current && this.props.selected.meta['initPos']) {
	        let yoffset = this.fld100xRef.current.clientHeight / 2;
	        let xoffset = this.fld100xRef.current.clientWidth / 2;
	        this.imageHolder.current.setTransform((-(this.props.selected.meta['initPos'][0]) * MAG) + xoffset, (-(this.props.selected.meta['initPos'][1]) * MAG) + yoffset, MAG)
        }
        this.setState({
            image_updated: false,
        })
        setTimeout(()=>{this.setState({pageRefresh:!this.state.page})},1000) //used to update zoom level display on top of image
    }

    componentDidMount = () => {
        this.timer = setTimeout(() => {
            this.setState({ resetOnFirstLoad: true });
        }, 2000);

        if (this.state.resetOnFirstLoad === true) {
            this.reposition();
            this.setState({ resetOnFirstLoad: false });
        }
    }

    componentDidUpdate = (prevProps, prevState) => {

        if (this.state.prevZstackIndex !== this.state.currZStackIndex) {
            this.setState({
                loadingImage: true
            });
            this.setState({prevZstackIndex: this.state.currZStackIndex})
        }

        if (prevProps.meta === undefined && this.props.meta !== undefined) {
            this.timer = setTimeout(() => {
                this.setState({ resetOnFirstLoad: true });
            }, 1000);

        }
        if (this.state.resetOnFirstLoad === true) {
            this.reposition();
            this.setState({resetOnFirstLoad: false});
        }
        if (prevProps.selected !== this.props.selected) {
            this.reposition();
            if (prevProps.selected.image !== this.props.selected.image) {
                this.setState({
                    loadingImage: true
                });
            } else if (this.props.blood_class === bloodClass.WBC) {
                this.setState({
                    loadingImage: true
                });
            }
            if (this.props.selected !== "" && this.props.selected.meta['initZStack'] !== undefined) {
                this.setState({
                    currZStackIndex: this.props.selected.meta['ZStacks'].indexOf(this.props.selected.meta['initZStack']),
                    zStacks: this.props.selected.meta['ZStacks'],
                    ZStackStep: this.props.selected.meta['ZStackStep']
                })
            }
            if (this.props.mode !== bloodClass.FIELD && this.props.selected.meta) {
                this.setState({
                    annotations:
                        [{
                            "geometry": {
                                "type": "RECTANGLE",
                                "x": (this.props.selected.meta['initPos'][0] / bloodImageProperties.WIDTH * 100) - 12,
                                "y": (this.props.selected.meta['initPos'][1] / bloodImageProperties.HEIGHT * 100) - 12,
                                "width": 24,
                                "height": 24
                            },
                            "data": {
                                "text": <span
                                    style={{color: "black", fontSize: "2.5vw"}}>{this.props.selected.class}</span>,
                                "id": Math.random()
                            }
                        }]
                });
            }
        }
        if (prevProps.selected.id !== this.props.selected.id) {
            this.setState({
                image_updated: true,
            })
        }
    }

    onWheel = (ref, event) => {
        event.preventDefault();
        if (event.shiftKey !== false && event.shiftKey !== 'false') {
            if (event.wheelDelta > 0) {
                this.higherZstack();
            } else {
                this.lowerZstack();
            }
        } else {
            if (event.wheelDelta > 0) {
                this.imageHolder.current.zoomIn(0.3);
            } else {
                this.imageHolder.current.zoomOut(0.3);
            }
        }
    }

    higherZstack = () => {
        let zStacks = ((this.props.selected || {}).meta || {})['ZStacks']
        let idx = this.state.currZStackIndex
        if (zStacks === undefined || idx === zStacks.length - 1) {
            return;
        }
        this.setState({
            currZStackIndex: idx + 1,
        })
    }

    lowerZstack = () => {
        let zStacks = ((this.props.selected||{}).meta||{})['ZStacks']
        let idx = this.state.currZStackIndex
        if (idx === 0 || zStacks === undefined) {
            return;
        }
        this.setState({
            currZStackIndex: idx - 1,
        })
    }

    updateZStackURL = (url_) => {
        let url = url_;
        url = url.split('/')
        let currZStackIndex = this.state.currZStackIndex
        let zStack;
        currZStackIndex = parseInt(currZStackIndex)
        if (parseInt(currZStackIndex) === '') {
            zStack = 0;
        } else {
            zStack = this.state.zStacks[currZStackIndex]
        }

        if (zStack === 0) {
            let idx = url.indexOf('stack');
            if (idx === -1) {
                url = url.join('/')
                return url;
            }
            url[idx] = 'tiled'
            url.splice(idx + 1, 1);
        }
        else {
            let idx = url.indexOf('tiled')
            if (idx === -1) {
                let idx = url.indexOf('stack');
                url[idx + 1] = `S${zStack}`
            } else {
                url[idx] = `stack/S${zStack}`
            }
        }
        url = url.join('/')
        return url
    }

    handleImageLoaded() {
        this.setState({
            loadingImage: false
        })
    }

    getView = (url, antIcon) => {
	    let view;
	    let filter = convertSettingsToFilter(this.props.cssfilter);
        if(this.props.mode === bloodClass.FIELD){
            view=<React.Fragment>
                    <Spin indicator={antIcon} spinning={this.state.loadingImage} wrapperClassName={'full-parent'}>
	                    <img
		                    src={url}
		                    style={{filter,}}
		                    onLoad={this.handleImageLoaded.bind(this)}
	                    />
                    </Spin>
                </React.Fragment>
        } else {
	        view = <Spin indicator={antIcon} spinning={this.state.loadingImage} wrapperClassName={'full-parent'}>
		        <div className={'full-parent'}
		             style={{filter,}}>
			        <Annotation
				        handleImageLoaded={this.handleImageLoaded.bind(this)}
				        src={url}
				        annotations={this.state.annotations}
				        type={this.state.type}
				        value={this.state.annotation}
				        disableAnnotation
				        style={{height: bloodImageProperties.HEIGHT, width: bloodImageProperties.WIDTH}}
				        disableOverlay
				        disableEditor
				        disableSelector
				        allowTouch
			        />
		        </div>
	        </Spin>
        }
	    return view;
    }

	zoomLevelDisplay = (zoom) => {
		return (<div className={'full-parent'}
		             style={{
			             backgroundColor: 'rgba(255,255,255,0.5)',
			             borderRadius: '10px',
			             padding: '5px'
		             }}>
			<Text className={'full-parent flex-center'} style={{color: '#3a4241', fontSize: '24px'}}>
				{(zoom * 300).toFixed(0)} X
			</Text>
		</div>)
	}

	render() {
		let zoomLevel_ = (((this.imageHolder || {}).current || {}).state || {}).scale
		if (isNull(zoomLevel_)) {
			this.props.mode === bloodClass.FIELD ? zoomLevel_ = 0.3 : zoomLevel_ = 1;
		}

		let url = ''
		if ((this.props.selected || {}).image) {
			url = this.updateZStackURL(this.props.selected.image)
        }

        if (this.props.selected === '') {
            return <div style={{ textAlign: 'center' }}>
                <Empty
                    style={this.props.view_mode === 1 ? { margin: '2vw', marginTop: '20vh', height: '20vh', width: '42vw' } : { margin: '210px', height: '683px', width: '816.3px' }}
                    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                    imageStyle={{
                        height: 100,
                    }}
                    description={
                        <span style={{ color: 'white' }}>
                            Select an Image to view at 100x
                    </span>
                    }
                >
                </Empty>
            </div>
        }

		let zStackMicrons = (this.state.zStacks[this.state.currZStackIndex] * this.props.selected.meta['ZStackStep']).toFixed(2)
		let antIcon = <LoadingOutlined style={{fontSize: 0}} spin/>;

		let viewchooser = this.getView(url, antIcon);

		let boundingHeight = 1080;
		if (notNull(this.fld100xRef.current)) {
			boundingHeight = (this.fld100xRef.current || {}).clientHeight - 40;
		}

		let fontSize = 20;
		if (window.innerWidth < 1400) {
			fontSize = 14;
		}

		return (
			<div className={'full-parent'} ref={this.fld100xRef}>
				<Row className={'full-parent'} style={{height: '95%', maxHeight: boundingHeight}}>
					<Row className={'full-parent'}>
						{this.props.view_mode === 1 ?
							<TransformWrapper
								id="img-wrapper"
								ref={this.imageHolder}
								centerZoomedOut={this.props.mode === bloodClass.FIELD}
								centerOnInit={this.props.mode === bloodClass.FIELD}
								minScale={0.2}
								maxScale={4}
								limitToBounds={true}
								initialPositionY={0}
								initialPositionX={0}
								onInit={this.state.image_updated ? this.reposition() : null}
								onWheelStart={this.onWheel}
								wheel={{'step': 0}}
								onZoom={() => {
									this.setState({pageRefresh: !this.state.pageRefresh})
								}} //used to update zoom level display on top of image
							>
								{({zoomIn, zoomOut, resetTransform, ...rest}) => (
									<TransformComponent
										wrapperStyle={{height: '100%', marginLeft: '5px', width: 'calc(100% - 10px)'}}>
										{viewchooser}
									</TransformComponent>
								)}
							</TransformWrapper>
							:
							<TransformWrapper
								ref={this.imageHolder}
								centerZoomedOut={this.props.mode === bloodClass.FIELD}
								centerOnInit={this.props.mode === bloodClass.FIELD}
								minScale={0.2}
								maxScale={3}
								initialPositionX={119}
								initialPositionY={20}
							>
								{({zoomIn, zoomOut, resetTransform, ...rest}) => (
									<React.Fragment>
										<div style={{
											position: 'fixed',
											bottom: '2vh',
											borderWidth: '0px',
											borderColor: 'rgba(0,0,0,0)'
										}}>
											<Button style={{
												height: 'auto',
												textAlign: 'center',
												backgroundColor: '',
												borderColor: 'rgba(0,0,0,0)',
												borderWidth: '0px'
											}} onClick={() => zoomIn()}><ZoomInOutlined/></Button>
											<Button style={{
												height: 'auto',
												textAlign: 'center',
												backgroundColor: '',
												borderColor: 'rgba(0,0,0,0)',
												borderWidth: '0px'
											}} onClick={() => zoomOut()}><ZoomOutOutlined/></Button>
											<Button style={{
												height: 'auto',
												textAlign: 'center',
												backgroundColor: '',
												borderColor: 'rgba(0,0,0,0)',
												borderWidth: '0px'
											}} onClick={() => resetTransform()}><CompressOutlined/></Button>
										</div>
										<TransformComponent wrapperStyle={{
											margin: '70px',
											marginTop: '-6px',
											height: '700px',
											width: '1100px',
											borderStyle: 'solid',
											borderWidth: '1px',
											borderColor: '#03112c',
											backgroundColor: '#03112c'
										}}
										>
											<img
												src={this.props.selected.image}
											/>
										</TransformComponent>
									</React.Fragment>
								)}
							</TransformWrapper>
						}
					</Row>
					<Row className={'full-parent'}
					     style={{position: 'absolute', left: '0', height: '5px', bottom: '7px', zIndex: '200'}}>
						<Progress strokeWidth={this.state.loadingImage ? "4px" : "0px"}
						          status={this.state.loadingImage ? "active" : {}}
						          percent={this.state.loadingImage ? 43 : 100}
						          className={'full-parent'}
						          showInfo={false}/>
					</Row>
					<Row className={'full-parent'} style={{
						position: 'absolute',
						right: '12px',
						height: '50px',
						width: '100px',
						bottom: '7px',
						zIndex: '200'
					}}>
						{this.zoomLevelDisplay(zoomLevel_)}
					</Row>
				</Row>

				<Row className={'full-parent'}
				     style={{height: '5%', minHeight: 40, color: 'white', fontSize: `${fontSize}px`}}>
					<Col className={'full-height'} span={4}>
						<Text className={'full-parent flex-center'}
                              style={{color: 'white', fontSize: `${fontSize - 1}px`}}>
                            ZSTACK:
                        </Text>
					</Col>

					<Col className={'full-height'} span={8}>

                        <Col className={'full-height flex-center'} span={3}>
                            <Button className={'strip-button-blood'} onClick={this.higherZstack}>
                                <PlusCircleOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                            </Button>
                        </Col>
                        <Col className={'full-height'} span={16}>
                            <Tooltip title={<p>Use Shift + &#129053; &amp; &#129055; to toggle</p>}>
                                <Text className={'full-parent flex-center'} style={{color: 'white'}}>
                                    {zStackMicrons >= 0 ? "+" + zStackMicrons : zStackMicrons} μ
                                </Text>
                            </Tooltip>
                        </Col>
                        <Col className={'full-height flex-center'} span={3}>
                            <Button className={'strip-button-blood'} onClick={this.lowerZstack}>
                                <MinusCircleOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
                            </Button>
						</Col>
					</Col>

					<Col className={'full-height'} span={12}>
						<Col className={'full-height'} span={12}>
							<Col className={'full-height flex-center'} span={8}>
								<Button className={'strip-button-blood'} onClick={() => this.props.loadPrev(0)}>
									<LeftCircleOutlined
										style={{color: 'cyan', fontSize: `${fontSize}px`}}></LeftCircleOutlined>
								</Button>
							</Col>
							<Col className={'full-height'} span={8}>
								<Tooltip title={<p>Use &#129052; &amp; &#129054; to toggle</p>}>
									<Text className={'full-parent flex-center'} style={{color: 'white'}}>
										#{this.props.selected.overall_count}
									</Text>
								</Tooltip>
							</Col>
							<Col className={'full-height flex-center'} span={8}>
								<Button className={'strip-button-blood'} onClick={() => this.props.loadNext(0)}>
									<RightCircleOutlined
										style={{color: 'cyan', fontSize: `${fontSize}px`}}></RightCircleOutlined>
								</Button>
							</Col>
						</Col>
						<Col className={'full-height'} span={12}>
							<Col className={'full-height flex-center'} span={8}>
								<Button className={'strip-button-blood'}
								        onClick={() => {
									        this.reposition().then(r => {
										        this.setState({pageRefresh: !this.state.page})
									        })
								        }}>
									<CompressOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
								</Button>
							</Col>
							<Col className={'full-height flex-center'} span={8}>
								<Button className={'strip-button-blood'}
								        onClick={() => {
									        this.imageHolder.current.zoomOut();
									        setTimeout(() => {
										        this.setState({pageRefresh: !this.state.page})
									        }, 1000)
								        }}>
									<ZoomOutOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
								</Button>
							</Col>
							<Col className={'full-height flex-center'} span={8}>
								<Button className={'strip-button-blood'}
								        onClick={() => {
									        this.imageHolder.current.zoomIn();
									        setTimeout(() => {
										        this.setState({pageRefresh: !this.state.page})
									        }, 1000)
								        }}>
									<ZoomInOutlined style={{color: 'cyan', fontSize: `${fontSize}px`}}/>
								</Button>
							</Col>
						</Col>
					</Col>
				</Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {

    };
};

export default connect(mapStateToProps)(Field100xView);

